module.exports = "<header class=\"fixed-top\">\n    <nav>\n        <img class=\"logo img-responsive\" [src]=\"imgPath\" width=\"150\">\n    </nav>\n</header>\n"